import React from 'react';
import {Button, Modal} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import SubscriptionPanel from './SubscriptionPanel';

// Boîte de dialogue « Mon abonnement » (montée une seule fois par PlanContext, ouverte depuis le
// menu profil de la sidebar ET depuis les ressources bloquées de la formule gratuite).
export default ({intl, plan, limitReason, show, onClose}) => (
  <Modal as={Modal.Dialog} centered size="lg" show={show} onHide={onClose}>
    <Modal.Header>
      <Modal.Title className="h6"><FormattedMessage id="MY_SUBSCRIPTION"/></Modal.Title>
      <Button variant="close" aria-label="Close" onClick={onClose}/>
    </Modal.Header>
    <Modal.Body>
      {show && <SubscriptionPanel intl={intl} plan={plan} limitReason={limitReason}/>}
    </Modal.Body>
  </Modal>
);
